import React, {Component} from 'react';
import {connect} from 'react-redux';
import ApiActions from 'go/actions/api';
import {Segment} from 'semantic-ui-react';
import TopLevel from './TopLevel';
import _ from 'lodash';
import {API_SUBAWARDREC_GET_SUCCESS} from 'common/types';
import SideNavInternal from 'go/components/dynamic/layout/SideNavInternal';
// import {isSubApplicationConfig} from 'go/components/dynamic/modules/grantLandingPage/utils';
import {isFemaUser} from 'common/utils';

const defaultActive = 'SubAwardRecommendation';
const subawardrecommendation = {
  itemName: 'subAwardRecommendation',
  label: 'Subaward recommendation',
};
export class SubAwardRecommendationNavItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checking: true,
      shouldLoad: false,
      hasBeenExpanded: false,
      activeSubPage: defaultActive,
      config: null,
      subItems: [subawardrecommendation],
    };
  }

  componentDidMount() {
    let {token, grantId, subGrantId, hasFemaPermissions} = this.props;
    if (hasFemaPermissions) {
      this.props
        .getSubAwardRecommendation(token, grantId, subGrantId)
        .then((res) => {
          if (res.type === API_SUBAWARDREC_GET_SUCCESS) {
            // we have the config for the subaward recommendation from this res along the data... but can't be sure
            // that other nav items will get their own configs, so rely on the landing page to provide
            this.setState({
              shouldLoad: true,
            });
          }
          this.setState({
            checking: false,
          });
        })
        .catch((err) => {
          console.log(
            `Subawardrecommendation could not be retrieved for subGrantId: ${subGrantId}.`,
            err
          );
          this.setState({
            checking: false,
          });
        });
    } else {
      this.setState({
        checking: false,
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isActive !== this.props.isActive) {
      this.setState({
        hasBeenExpanded: true,
      });
    }
  }

  setActivePage(configName) {
    this.props.loadPageWithConfig(configName).then((config) => {
      this.setState({
        activeSubPage: configName,
        config: config,
      });
    });
  }

  render() {
    const {baseClass, isActive, config} = this.props;
    const SubAwardRecommendationName = 'Subaward recommendation';
    const activePage = 'subAwardRecommendation';
    if (this.state.checking) {
      return (
        <Segment tertiary inverted>
          Checking for SubAwardRecommendation...
        </Segment>
      );
    } else if (this.state.shouldLoad) {
      return (
        <React.Fragment>
          <TopLevel
            name={SubAwardRecommendationName}
            baseClass={baseClass}
            handleClick={() => this.setActivePage(activePage)}
            active={isActive}
            isExpandable={false}
          />
          {isActive && config && (
            <React.Fragment>
              <SideNavInternal
                navToSpecificLocation={() => {
                  /* this is the key to making the sidenav active state work
                          don't use until figuring out how to incorporate VisibilitySensor into this
                        */
                }}
                location={this.props.location}
                title={SubAwardRecommendationName + ' navigation'}
                {...config.payload}
              />
            </React.Fragment>
          )}
        </React.Fragment>
      );
    } else {
      return <React.Fragment />;
    }
  }
}

export const mapDispatchToProps = (dispatch) => ({
  getSubAwardRecommendation: (token, grantId, subGrantId) => {
    const action = ApiActions.subawardRecommendation.getSubAwardRecommendation(
      token,
      grantId,
      subGrantId
    );
    const res = dispatch(action);
    return res;
  },
});

export const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    hasFemaPermissions: isFemaUser(state.auth.permissions),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubAwardRecommendationNavItem);
